import React from 'react';
import { Modal, ModalFooter } from '@/components/common';
import { LabDTO } from '@/models';

interface LabDeleteModalProps {
  isOpen: boolean;
  lab: LabDTO | null;
  isSaving: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const LabDeleteModal: React.FC<LabDeleteModalProps> = ({
  isOpen,
  lab,
  isSaving,
  onConfirm,
  onClose,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnBackdropClick={false}
      title="Delete Lab"
      footer={
        <ModalFooter
          onCancel={onClose}
          onConfirm={onConfirm}
          confirmText="Delete"
          confirmVariant="danger"
          isLoading={isSaving}
        />
      }
    >
      <p>
        Are you sure you want to delete lab <strong>{lab?.name}</strong>? This action cannot be
        undone. The backend will reject deletion while dependent records still exist.
      </p>
    </Modal>
  );
};
